module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('Carousel', {
    attrs: {
      "id": "top-ad-carousel",
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "title": item.aname
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "alt": item.aname,
        "height": "80px",
        "width": "1200px"
      }
    })])], 1)
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cebe96d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fresh-agricultural/top-ad.vue
// module id = 1645
// module chunks = 1